import React from "react";

const TextArea = ({
  id,
  title = "",
  wrapperClassName = "",
  type = "text",
  placeholder = "",
  containerClassName = "",
  inputClassName = "",
  labelClassName = "",
  required = false,
  disabled = false,
  rows = "5",
  onChange,
  value = "",
  error = "",
  showRemaining = true,
  maxChars = 250,
}) => {
  return (
    <div className={`flex flex-col ${wrapperClassName}`}>
      {title ? (
        <label
          htmlFor={id}
          className={`font-size-small text-[var(--blackColor)] mb-2 ${labelClassName}`}
        >
          {title}
          {required ? <span className="text-[#e55353]"> *</span> : null}
        </label>
      ) : null}

      <div className={`input-container ${containerClassName}`}>
        <textarea
          type={type}
          placeholder={placeholder}
          className={`input-field font-size-medium resize-none py-3 ${inputClassName}`}
          disabled={disabled}
          rows={rows}
          value={value}
          onChange={(e) => {
            if (e.target.value?.length <= maxChars) {
              onChange(e.target.value);
            }
          }}
        />
      </div>
      {showRemaining && (
        <div className="font-size-extra-small mt-2 self-end">
          Remaining characters:{" "}
          <span className="text-[var(--textRed)]">
            {maxChars - value?.length}
          </span>
        </div>
      )}
      {error ? (
        <div className={`font-size-small text-[var(--textRed)] mt-2`}>
          {error}
        </div>
      ) : null}
    </div>
  );
};

export default TextArea;
